<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="topimg bg-100"></div>
            <div class="hint r16">
                <zbSwiper
                    ref="swiper"
                    :options="swiperOptions"
                    :data="breakCarList"
                    :isCustom="true"
                    designWidth="670"
                    designHeight="354"
                    class="shadow-bg r16 swipe"
                >
                    <van-swipe-item
                        v-for="(item, index) in breakCarList"
                        :key="index"
                        class="r16 bv bc"
                    >
                        <div class="carCard r16">
                            <div class="fz_34 bh bstart">
                                <i class="ico-car bg-contain"></i>
                                {{item.carNumber}}
                            </div>
                            <div class="bh bc tc info">
                                <div class="b1">
                                    <div class="fz_40" :class="item.flagCls">{{item.showTotal}}</div>
                                    <div class="fz_28 c_666">违章数</div>
                                </div>
                                <div class="b1">
                                    <div class="fz_40" :class="item.flagCls">{{item.showTotalFine}}</div>
                                    <div class="fz_28 c_666">罚款金额(元)</div>
                                </div>
                                <div class="b1">
                                    <div
                                        class="fz_40"
                                        :class="item.flagCls"
                                    >{{item.showTotalDegree}}</div>
                                    <div class="fz_28 c_666">待扣分</div>
                                </div>
                            </div>
                            <div class="bh bc">
                                <van-button
                                    class="btn btn-goodcart"
                                    v-on:click.native="onDelClick(item.cusCarId)"
                                >
                                    <div class="fz_28">删除</div>
                                </van-button>&emsp;
                                <van-button
                                    class="btn btn-goodbuy"
                                    v-on:click.native="getBreakList({id:item.cusCarId,name:item.carNumber})"
                                >
                                    <div class="fz_28">查看详情</div>
                                </van-button>
                            </div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item class="r16">
                        <div
                            class="addCard bh bc r16"
                            v-on:click="go('BreakCarEdit', {isEdit:false})"
                        >
                            <i class="ico-bg-add bg-contain"></i>
                            <div>
                                <div class="fz_34 title">添加您的爱车</div>
                                <div class="fz_24 c_999">首次付费后，一周内可免费查询</div>
                            </div>
                        </div>
                    </van-swipe-item>
                </zbSwiper>
            </div>
            <div class="more">
                <div class="fz_34 tc c_666">更多车主服务</div>
                <div class="btn-list">
                    <div
                        v-for="(item,index) in btnList"
                        :key="index"
                        class="list-item list-item-inline"
                    >
                        <div class="item shadow-bg bv bc" v-on:click="go(item.go)">
                            <div
                                class="img bg-contain"
                                :class="item.ico"
                                v-on:click.stop="go(item.go)"
                            ></div>
                            <div class="c_666 fz_30 title">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { mixinBreak } from "@/mixin/break";
import { delCar } from "@/api/break";
import zbSwiper from "@/components/swiper/Container";
import util from "@/utils/index";
export default {
    mixins: [user, mixinBreak],
    name: "BreakCarHome",
    components: { zbSwiper },
    data() {
        return {
            breakCarId: -1,
            swiperOptions: {
                loop: false
            },
            btnList: [
                {
                    name: "驾照查分",
                    ico: "ico-illegal",
                    go: "BreakDrivingHome"
                },
                {
                    name: "罚款代缴",
                    ico: "ico-annual",
                    go: ""
                },
                {
                    name: "年检代办",
                    ico: "ico-insurance",
                    go: ""
                }
            ]
        };
    },
    computed: {
        breakCarList() {
            return this.$store.state.illegal.carList;
        },
        swipeData() {
            return { list: this.breakCarList, id: this.breakCarId };
        }
    },
    watch: {
        // 取消支付返回时选中车辆
        swipeData(data) {
            const { id, list } = data;
            // console.log(id, list);
            if (id != -1) {
                const index = util.getListIndex(list, id, "cusCarId");
                if (index != -1) {
                    this.$refs.swiper.swipeTo(index);
                    // 重置选中id
                    this.breakCarId = -1;
                }
            }
        }
    },
    activated() {
        // 页面激活时设置当前主键
        // 避免轮播主键位置不正确
        this.breakCarId = this.$store.state.illegal.carId;
    },
    methods: {
        onDelClick(id) {
            this.dialog
                .confirm({
                    title: "提示",
                    message: "确认删除当前车辆信息？"
                })
                .then(() => {
                    delCar(id).then(res => {
                        this.$store.dispatch("illegal/carList", true);
                    });
                });
        },
        // 获取用户数据后执行
        userLoginend() {
            // 获取车辆信息
            this.$store.dispatch("illegal/carList");
        }
    }
};
</script>
<style scoped lang="scss">
.scrollbar-container {
    background: #f7f8f8;
    .btn-goodbuy {
        margin-left: 10px;
        width: 150px;
        height: 60px;
    }
    .btn-goodcart {
        width: 150px;
        height: 60px;
    }
    .topimg {
        padding-top: 40%;
        background-image: url("~@/assets/imges/break/banner.png");
    }

    .hint {
        position: relative;
        margin: -210px 0 0 40px;
        width: 670px;
        .swipe {
            position: initial;
            /deep/.van-swipe__indicators {
                bottom: -30px;

                .van-swipe__indicator {
                    background: #aaa;
                }
            }
        }
        .addCard,
        .carCard {
            background: #fff;
        }
        .addCard {
            height: 100%;
            .ico-bg-add {
                width: 180px;
                height: 180px;
                margin-right: 34px;
            }
            .title {
                padding-bottom: 20px;
            }
        }

        .carCard {
            width: calc(100% - 80px);
            padding: 0 40px;
            .ico-car {
                width: 56px;
                height: 45px;
                margin-right: 12px;
            }
            .info {
                padding: 30px 0 40px 0;
            }
            .btn-goodbuy {
                width: 150px;
                height: 56px;
            }
        }
    }
    .more {
        padding: 100px 30px 0 30px;
        .btn-list {
            padding-top: 30px;
            .list-item {
                width: 33.3%;
                &:active {
                    .shadow-bg {
                        background: #eee;
                    }
                }
                .item {
                    margin: 10px;
                    padding-top: 40px;
                    .img {
                        width: 100px;
                        height: 100px;
                    }
                    .title {
                        padding: 20px 0 30px 0;
                    }
                }
            }
        }
    }
}
[data-theme="app"] {
    .scrollbar-container {
        .topimg {
            background-image: url("~@/assets/imges/app/break/banner.png");
        }
        .more {
            .btn-list {
                .list-item {
                    &:active {
                        .shadow-bg {
                            background: #c2b6b7;
                        }
                    }
                }
            }
        }
    }
}
</style>